export function getBallColorAndCrackState(balls) {
  const colors = balls.map((ball) => {
    return ball.ball;
  });

  const crackStates = balls.map((ball) => {
    return ball.crackedCount ? ball.crackedCount : ball.crackedcount; // wrong backend response when in initial is unfinished bonus
  });

  return {
    colors,
    crackStates,
  };
}